var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('Banner'),_c('Welcome'),_c('Services',{ref:"services",attrs:{"treatments":_vm.treatments}}),_c('About'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }